import type { ReactNode } from 'react';
import { WarningIcon } from '../../../assets/icons/warning-icon.tsx';
import { Notice } from '../../../components/ui/notice.tsx';
import Text from '../../../components/ui/text.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';

export const ErpConnectionErrorBanner = (): ReactNode => {
    const { t } = useLocale();

    return (
        <Notice
            variant="warning"
            title={t('erp_connection_error_banner___title')}
            icon={WarningIcon}
            description={<Text className="block">{t('erp_connection_error_banner___description')}</Text>}
        />
    );
};
